import { useDispatch, useSelector } from "react-redux";

const useCustomDispatch = () => {
  const dispatch = useDispatch();
  return dispatch;
};

const useCustomSelector = (selectorFn) => {
  const selector = useSelector(selectorFn);
  return selector;
};

export { useCustomDispatch, useCustomSelector };
